const rawUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "https://zulivio.nodedr.com";

export const site = {
  name: "Zulivio",
  shortName: "Zulivio",
  legalName: "NODEDR INFOTECH PRIVATE LIMITED",
  ownerName: "Raktim Ranjit",
  tagline: "Open-source telecalling CRM and humane workforce operations",
  description:
    "Zulivio is a free, open-source, self-hostable telecalling CRM and workforce-operations platform — a drag-and-drop lead pipeline, one-tap call dispositions, due-dated follow-ups and configurable lead scoring, plus role-based employee management, work assignments, attendance tracking and a live master dashboard. It runs on your own hardware, so your team's data never leaves your server. No subscription, no per-seat fee.",
  url: rawUrl.replace(/\/$/, ""),
  email: "info@nodedr.com",
  nodedrUrl: "https://www.nodedr.com",
  repoUrl: "https://github.com/Raktim94/zulivio",
  repoIssuesUrl: "https://github.com/Raktim94/zulivio/issues",
  installerUrl: "https://github.com/Raktim94/zulivio/blob/main/install.sh",
  licenseUrl: "https://github.com/Raktim94/zulivio/blob/main/LICENSE",
  formName: "Zulivio contact",
  submitPath: "/api/submit",
  thankYouPath: "/thank-you",
  ogImage: "/brand/logo.webp",
  port: 3100,
  debVersion: "1.12.1",
  installLinuxUrl: "https://zulivio.nodedr.com/install-linux.sh",
  debAmd64Url: "/downloads/zulivio-amd64.deb",
  debArm64Url: "/downloads/zulivio-arm64.deb",
} as const;

export function absoluteUrl(path: string): string {
  return new URL(path, site.url).toString();
}
